import React, { useState } from "react";
import MenuList from "../components/MenuList";

const Analytics = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <div className="flex flex-col h-screen">
      <div className="flex items-center space-x-4 px-4 py-2 mx-auto w-[87%]">
        <MenuList isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <h1 className="text-2xl text-orange-600">Analytics</h1>
      </div>
      <div className="flex-1 overflow-hidden mx-auto w-[85%]">
        <iframe
          title="report"
          width="100%"
          height="100%"
          src="https://lookerstudio.google.com/embed/reporting/2d04704f-cc6f-4170-aba7-34c2352ef939/page/p_5e8zbj0uqd"
          frameBorder="0"
          style={{ border: "0", margin: "auto" }}
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      </div>
    </div>
  );
};

export default Analytics;
